import React from 'react';
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ItemBrowserHeaderSelect from "../../components/ItemBrowserHeaderSelect";
import ItemBrowserHeaderSimpleSelect from "../../components/ItemBrowserHeaderSimpleSelect";

const EventsTheatreItemBrowserHeader = ({
                                              cityId,
                                              setCityId,
                                              locationId,
                                              setLocationId,
                                              tagId,
                                              setTagId,
                                              datesMode,
                                              setDatesMode,
                                              cardType,
                                              setCardType,
                                              ...restProps
                                          }) => {


    function renderExtraContent() {
        return (
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSelect
                    label="Город"
                    selectedId={cityId}
                    setSelectedId={setCityId}
                    apiName2="cities"
                    specialOptions={[{id: 0, name: "(все)"}]}
                    showIds={true}
                />
                <ItemBrowserHeaderSelect
                    label="Локация"
                    selectedId={locationId}
                    setSelectedId={setLocationId}
                    apiName2="locations"
                    specialOptions={[{id: 0, name: "(все)"}]}
                    showIds={true}
                />
                <ItemBrowserHeaderSelect
                    label="Наличие тега"
                    selectedId={tagId}
                    setSelectedId={setTagId}
                    apiName2="tags"
                    specialOptions={[{id: 0, name: "(не важно)"}]}
                    showIds={true}
                />
                <ItemBrowserHeaderSimpleSelect
                    label="Наличие дат"
                    options={datesModes}
                    value={datesMode}
                    setValue={setDatesMode}
                />
                <ItemBrowserHeaderSimpleSelect
                    label="Тип карточек"
                    options={cardTypeOptions}
                    value={cardType}
                    setValue={setCardType}
                />
            </div>
        );
    }

    return (
        <BaseSimpleItemBrowserHeader
            {...restProps}
            renderExtraContent={renderExtraContent}
        />
    );
};

const datesModes = [
    {id: "any", name: "(не важно)"},
    {id: "with_dates", name: "Есть даты"},
    {id: "without_dates", name: "Нет дат"},
];

const cardTypeOptions = [
    {id: "all", name: "(все)"},
    {id: "active", name: "Только активные"},
    {id: "deleted", name: "Только архивные"},
];

export default EventsTheatreItemBrowserHeader;